
/**
 * Format a number as currency - DEPRECATED: Use formatCurrency from @/lib/portfolioCalculations instead
 */
export const formatCurrency = (value: number, currency: string = 'CAD'): string => {
  // Handle null, undefined, NaN, or invalid values
  const numValue = Number(value);
  const safeValue = Number.isFinite(numValue) ? numValue : 0;

  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(safeValue);
};

/**
 * Format a number as percentage
 */
export const formatPercentage = (value: number): string => {
  // Format as percentage with 2 decimal places
  return new Intl.NumberFormat('en-CA', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100); // Divide by 100 to convert from basis points to percentage
};

/**
 * Format bytes to human readable format
 */
export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};
